import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/seo-entity-page/appEnv';

export default appStarterFactory(appEnv);
